import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/driver/fee/audit/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 审核
export function auditData(data) {
  return request.send({
    url: `/pmy/sys/driver/fee/audit`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

export function detailInfo(driverFeeId) {
  return request.send({
    url: `/pmy/sys/driver/fee/audit?driverFeeId=${driverFeeId}`,
    method: "get",
  });
}
